import { render, staticRenderFns } from "./loginpop.vue?vue&type=template&id=8836cec6&scoped=true&"
import script from "./loginpop.vue?vue&type=script&lang=js&"
export * from "./loginpop.vue?vue&type=script&lang=js&"
import style0 from "./loginpop.vue?vue&type=style&index=0&id=8836cec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8836cec6",
  null
  
)

export default component.exports